export default {
  path: '/trackers/tracker-firmwares',
  name: 'TrackerFirmwares',
  component: () => import(/* webpackChunkName: "base" */ '../views/TrackerFirmwaresView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
